<template>
    <div class="card">
        <div class="card-header">
            Media
        </div>
        <div class="card-body">
            <form>
                <form-alert />

                <media-table
                    :endpoint="`/admin/api/media?lesson_id=${lessonId}`"
                    :lesson-id="lessonId"
                >
                </media-table>

                <hr />

                <div class="row">
                    <div class="col-md-10">
                        <div class="form-group">
                            <label for="media_id">
                                Attach file
                            </label>
                            <form-select
                                v-model="mutableData.media_id"
                                name="media_id"
                                endpoint="/admin/api/media-options?category_not=series-image"
                                data-vv-as="File"
                            />
                        </div>
                    </div>

                    <div class="col-md-2">
                        <label>
                            &nbsp;&nbsp;
                        </label>
                        <button
                            :disabled="isSending"
                            class="btn btn-success btn-block w-100"
                            @click.prevent="submitForm()"
                        >
                            Add
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Form from "../mixins/Form.js";
import MediaTable from "./MediaTable.vue";

export default {
    components: {
        MediaTable
    },

    mixins: [
        Form,
    ],

    props: {
        lessonId: {
            type: Number,
            required: true,
        },
    },
};
</script>
